import React from 'react'
import { useState } from 'react';
import { FaRegLifeRing } from "react-icons/fa6";
import { FaRegRegistered } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { BiSolidUserBadge } from "react-icons/bi";

import { FaRegMessage } from "react-icons/fa6";
import { TbBrandGoogleFilled } from "react-icons/tb";
import { CiVoicemail } from "react-icons/ci";
import { FaChartBar } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";

import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDropleft } from "react-icons/io";




// components
import DynemicDeliveryBaseUserReports from './DynemicDeliveryBaseUserReports';


function DeliveryBaseUserReports() {

    const [activeTab, setActiveTab] = useState("SMSStatistics");

    const tabList = [
        {
            id: "SMSStatistics", label: "SMS Delivery Base User", icon: <FaRegMessage />
            , component: <DynemicDeliveryBaseUserReports   />
        },
        {
            id: "RCSStatistics", label: "RCS Delivery Base User", icon: <TbBrandGoogleFilled />
            , component: <DynemicDeliveryBaseUserReports  />
        },
        {
            id: "WhatsAppStatistics", label: "WhatsApp Delivery Base User", icon: <FaWhatsapp />
            , component: <DynemicDeliveryBaseUserReports  />
        },
        {
            id: "VoiceStatistics", label: "Voice Delivery Base User", icon: <CiVoicemail />
            , component: <DynemicDeliveryBaseUserReports  />
        },
        {
            id: "TTSStatistics", label: "TTS Delivery Base User", icon: <FaChartBar />
            , component: <DynemicDeliveryBaseUserReports   />
        },
        {
            id: "CTCStatistics", label: "CTC Delivery Base User", icon: <FaChartLine />
            , component: <DynemicDeliveryBaseUserReports   />
        },
    ];

    return (
        <>
            <div className='dark:bg-[#121519] min-h-screen md:pt-[70px] pt-[100px] '>

                <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex items-center gap-2  '>
                    <Link to='/Adminhome'>
                    <IoIosArrowDropleft className='text-[36px] dark:text-[#fff]' />
                    </Link>
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>DeliveryBase User</h1>
                        <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward /> <span>DeliveryBase User</span>  </div>
                    </div>
                </div>
                <div className=' w-[100%] flex gap-1 px-2 pt-4  '>
                    {tabList.map((item, index) =>
                        <button
                            onClick={() => setActiveTab(item.id)}
                            className={` w-[16%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                    )
                    }
                </div>
                <div className="pt-4 px-2 dark:bg-[#121519]">
                    {tabList.find((t) => t.id === activeTab)?.component}
                </div>
            </div>
        </>
    )
}

export default DeliveryBaseUserReports
